<template>
  <div>
    <div style="margin: 10px 0px">
      <div
        v-if="$vuetify.breakpoint.xsOnly"
        style="
          width: 50vw;
          max-height: 60px;
          white-space: pre;
          overflow: hidden;
          text-overflow: ellipsis;
          margin: 10px;
        "
      >{{ text }}</div>
      <div
        v-else
        style="
          width: 500px;
          max-height: 60px;
          white-space: pre;
          overflow: hidden;
          text-overflow: ellipsis;
          margin: 10px;
        "
      >{{ text }}</div>
      <v-btn
        v-show="checkDescriptionLength(text)"
        x-small
        right
        depressed
        @click="dialog = true"
        >Show More</v-btn
      >
    </div>
    <v-dialog v-model="dialog" width=" auto">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Description
        </v-card-title>

        <v-card-text>
          <div style="white-space: pre; padding: 20px; overflow: auto">{{ text }}</div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false"> Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import validationMixin from "@/mixins/validationMixin";

export default {
  components: {},
  props: {
    text: String,
    show: [Boolean, String],
  },
  mixins: [validationMixin],

  data() {
    return {
      dialog: false,
      valid: false,
      loading: false,
    };
  },

  watch: {
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },

    dialog(n, o) {
      if (!n && o) {
        this.onDialogClose();
      } else {
        this.onDialogOpen();
      }
    },
  },

  computed: {

    formTitle() {
      return this.isEdit ? "Edit Job" : "Add Time Clock";
    },
   
  },

  methods: {
    checkDescriptionLength(text) {
      return (text && text.length > 200) || (text && text.split("\n").length > 3);
    },

    onDialogClose() {
      if (this.isEdit) {
        //
      } else {
        //
      }
      this.$emit("onClosed");
    },

    onDialogOpen() {},

    completed() {
      this.$emit("onSucceded");
    },
  },
};
</script>